/** Mirrors the server's MAX_BYTES (extension/src/routes/leagueLogoFile.ts). */
export const LOGO_MAX_BYTES = 5 * 1024 * 1024;
/** nginx waits as long for the body on this site (client_body_timeout). */
export const UPLOAD_TIMEOUT_MS = 120_000;
const ACCEPTED = new Set(["image/png", "image/jpeg", "image/webp", "image/svg+xml"]);

export function formatMB(bytes: number): string {
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** A local check before anything goes over the network; null = fine. */
export function precheckLogo(file: { type: string; size: number }): string | null {
  if (file.size === 0) return "Fayl bo'sh";
  if (!ACCEPTED.has(file.type)) return "Faqat PNG, JPG, WebP yoki SVG";
  if (file.size > LOGO_MAX_BYTES) {
    return `Fayl ${formatMB(file.size)} — chegara ${formatMB(LOGO_MAX_BYTES)}`;
  }
  return null;
}

/** Why an upload failed, in words an operator can act on. */
export function uploadErrorText(r: {
  status: number | null;
  code: string | null;
  sizeBytes: number;
}): string {
  if (r.status === null) {
    return r.code === "timeout"
      ? "Server 2 daqiqada javob bermadi — internet sekin yoki fayl katta"
      : "Serverga ulanib bo'lmadi — internetni tekshiring";
  }
  switch (r.code) {
    case "too_large":
      return `Fayl ${formatMB(r.sizeBytes)} — chegara ${formatMB(LOGO_MAX_BYTES)}`;
    case "unsupported_type":
      return "Faqat PNG, JPG, WebP yoki SVG";
    case "empty":
      return "Fayl bo'sh";
  }
  if (r.status === 401) return "Sessiya tugagan — qayta kiring";
  if (r.status === 408) return "Yuklash juda uzoq davom etdi — internet sekin yoki fayl katta";
  if (r.status === 413) return `Fayl juda katta (${formatMB(r.sizeBytes)})`;
  if (r.status >= 500) return `Server xatosi (${r.status}) — birozdan keyin qayta urinib ko'ring`;
  return `Yuklab bo'lmadi (${r.status})`;
}
